import React from 'react';
import { Section, FadeIn } from './ui/Section';
export function WhatIsAntiImpulso() {
  return <Section background="white" className="border-t border-[#E8D5DC]/50" data-id="element-256">
      <FadeIn data-id="element-257">
        <div className="text-center mb-12" data-id="element-258">
          <span className="text-[#C4467E] font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-259">
            El Concepto
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-[#3D1F2E] mb-6" data-id="element-260">
            Esto es Anti‑Impulso.
          </h2>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-261">
        <div className="prose prose-lg prose-stone mx-auto text-[#7A5C6B] leading-relaxed" data-id="element-262">
          <p className="text-xl md:text-2xl font-serif text-[#3D1F2E] mb-8 text-center" data-id="element-263">
            Un sistema de 14 días para cortar compras compulsivas sin volverte
            una persona "restrictiva" y sin vivir en guerra contigo.
          </p>

          <FadeIn delay={0.3} data-id="element-264">
            <div className="my-12" data-id="element-265">
              <img src="https://cdn.magicpatterns.com/uploads/h241stnUBcHgWd2SzzrFSw/Anti_impulso_cover.png" alt="Anti-Impulso — Vista del producto digital en laptop y celular" className="w-full max-w-2xl mx-auto rounded-2xl shadow-xl" data-id="element-266" />
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-12" data-id="element-267">
            <div className="bg-[#FFF5F0]/80 backdrop-blur-sm p-6 rounded-xl text-center" data-id="element-268">
              <span className="text-3xl mb-4 block" data-id="element-269">🚫</span>
              <p className="font-medium text-[#3D1F2E]" data-id="element-270">
                No es un curso eterno.
              </p>
            </div>
            <div className="bg-[#FFF5F0]/80 backdrop-blur-sm p-6 rounded-xl text-center" data-id="element-271">
              <span className="text-3xl mb-4 block" data-id="element-272">📊</span>
              <p className="font-medium text-[#3D1F2E]" data-id="element-273">
                No es un Excel bonito que vas a abandonar.
              </p>
            </div>
            <div className="bg-[#FFF5F0]/80 backdrop-blur-sm p-6 rounded-xl text-center" data-id="element-274">
              <span className="text-3xl mb-4 block" data-id="element-275">💪</span>
              <p className="font-medium text-[#3D1F2E]" data-id="element-276">
                No es "échale ganas".
              </p>
            </div>
          </div>

          <p className="text-center text-lg" data-id="element-277">
            Es una estructura simple para que, cuando llegue el impulso,{' '}
            <span className="font-bold text-[#C4467E]" data-id="element-278">
              no tengas que negociar contigo misma.
            </span>
          </p>
        </div>
      </FadeIn>
    </Section>;
}